import * as React from "react";
import {
  Text,
  View,
  Image,
  Button,
  FlatList,
  TouchableOpacity,
} from "react-native";
import { NavigationContainer, useTheme } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";

import { LinearGradient } from "expo-linear-gradient";

import Colors from "../utils/colors";
import * as firebase from "firebase";
import { SafeAreaView } from "react-native-safe-area-context";
import { auth } from "firebase";

// import stockData from '../stockData'

class HomeScreen extends React.Component {
  state = {
    date: "",

    userStocks: [],
    resultStocks: [],
  };
  async componentDidMount() {
    this.getUserStocks();
  }

  getUserStocks = () => {
    // want to see last week picks and detailed results
    // want to see overall analysis
    firebase
      .database()
      .ref("userPicks/" + this.props.route.params.uid + "/")

      .once("value")
      .then((snapshot) => {
        const vals = snapshot.val();

        this.getResultStocks(
          this.props.route.params.date,
          this.props.route.params.name
        );
        this.setState({
          date: this.props.route.params.date,
          userStocks:
            vals[this.props.route.params.date][this.props.route.params.name],
        });

      
      });
  };

  getResultStocks = (date, industry) => {
    // want to see last week picks and detailed results
    // want to see overall analysis
    firebase
      .database()
      .ref("results/" + date + "/" + industry)
      .once("value")
      .then((snapshot) => {
        const vals = snapshot.val();
        this.setState({
          resultStocks: vals,
        });

        return vals;
      });
  };

  render() {
    return (
      <SafeAreaView style={{ flex: 1 }}>
        <FlatList
          numColumns={1}
          data={this.state.userStocks}
          ListHeaderComponent={
            <Text
              style={{
                color: "white",
                fontFamily: "ArialMT",
                fontSize: 20,
                position: "relative",
                textAlign: "center", // <-- the magic
              }}
            >
              {this.state.date} Picks {this.props.route.params.name}
            </Text>
          }
          renderItem={(item) => {
            return (
              <View
                style={{
                  flex: 1,
                  flexDirection: "row",
                }}
              >
                <LinearGradient
                  colors={
                    1 > 0 ? ["#80ffa0", "#bfffcf"] : ["#ff8080", "#ffbfbf"]
                    // ["#ff8080", "#ffbfbf"]
                  }
                  style={{
                    height: 100,
                    margin: 5,
                    width: "40%",
                    alignItems: "center",
                    borderRadius: 10,
                    justifyContent: "center",
                  }}
                >
                  {this.state.resultStocks[item["index"]] !== undefined ? (
                    <View
                      style={{
                        backgroundColor: "transparent",
                        fontSize: 20,
                        color: "black",
                        //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                      }}
                    >
                      <Image
                        // defaultSource={{
                        //   uri:
                        //     "https://eodhistoricaldata.com/img/logos/US/" +
                        //     item["item"]["stock1"]["symbol"].toLowerCase() +
                        //     ".png",
                        // }}
                        source={{
                          uri:
                            // "https://g.foolcdn.com/art/companylogos/square/" +
                            // item["item"]["stock1"]["symbol"].toLowerCase() +
                            // ".png",
                            "https://eodhistoricaldata.com/img/logos/US/" +
                            item["item"]["stock1"]["symbol"].toUpperCase() +
                            ".png",
                        }}
                        style={{
                          width: 50,
                          height: 50,
                          borderRadius: 10,
                        }}
                      />
                      {item["item"]["stock1"]["symbol"] ===
                      this.state.resultStocks[item["index"]]["stock1"][
                        "symbol"
                      ] ? (
                        <Text
                          style={{
                            backgroundColor: "transparent",
                            fontSize: 20,
                            color: "black",
                            //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                          }}
                        >
                          yours: {item["item"]["stock1"]["symbol"]}
                        </Text>
                      ) : (
                        <View>
                          <Text
                            style={{
                              backgroundColor: "transparent",
                              fontSize: 20,
                              color: "black",
                              textDecorationLine: "line-through",
                              textDecorationStyle: "solid",
                            }}
                          >
                            yours: {item["item"]["stock1"]["symbol"]}
                          </Text>

                          <Text
                            style={{
                              backgroundColor: "transparent",
                              fontSize: 20,
                              color: "black",
                            }}
                          >
                            {
                              this.state.resultStocks[item["index"]]["stock1"][
                                "symbol"
                              ]
                            }
                          </Text>
                        </View>
                      )}
                    </View>
                  ) : null}
                </LinearGradient>

                <LinearGradient
                  // Button Linear Gradient
                  colors={
                    -1 > 0 ? ["#80ffa0", "#bfffcf"] : ["#ff8080", "#ffbfbf"]
                  }
                  style={{
                    height: 100,
                    margin: 5,
                    width: "40%",

                    alignItems: "center",
                    borderRadius: 10,
                    justifyContent: "center",
                  }}
                >
                  {this.state.resultStocks[item["index"]] !== undefined ? (
                    <View
                      style={{
                        backgroundColor: "transparent",
                        fontSize: 20,
                        color: "black",
                        //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                      }}
                    >
                      <Image
                        // defaultSource={{
                        //   uri:
                        //     "https://eodhistoricaldata.com/img/logos/US/" +
                        //     item["item"]["stock2"]["symbol"].toLowerCase() +
                        //     ".png",
                        // }}
                        source={{
                          uri:
                            // "https://g.foolcdn.com/art/companylogos/square/" +
                            // item["item"]["stock2"]["symbol"].toLowerCase() +
                            // ".png",
                            "https://eodhistoricaldata.com/img/logos/US/" +
                            item["item"]["stock2"]["symbol"].toUpperCase() +
                            ".png",
                        }}
                        style={{
                          width: 50,
                          height: 50,
                          borderRadius: 10,
                        }}
                      />
                      {item["item"]["stock2"]["symbol"] ===
                      this.state.resultStocks[item["index"]]["stock2"][
                        "symbol"
                      ] ? (
                        <Text
                          style={{
                            backgroundColor: "transparent",
                            fontSize: 20,
                            color: "black",
                            //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                          }}
                        >
                          yours: {item["item"]["stock2"]["symbol"]}
                        </Text>
                      ) : (
                        <View>
                          <Text
                            style={{
                              backgroundColor: "transparent",
                              fontSize: 20,
                              color: "black",
                              textDecorationLine: "line-through",
                              textDecorationStyle: "solid",
                            }}
                          >
                            yours: {item["item"]["stock2"]["symbol"]}
                          </Text>

                          <Text
                            style={{
                              backgroundColor: "transparent",
                              fontSize: 20,
                              color: "black",
                            }}
                          >
                            {
                              this.state.resultStocks[item["index"]]["stock2"][
                                "symbol"
                              ]
                            }
                          </Text>
                        </View>
                      )}
                    </View>
                  ) : null}
                </LinearGradient>
                {this.state.resultStocks[item["index"]] !== undefined ? (
                  item["item"]["stock1"]["symbol"] ===
                    this.state.resultStocks[item["index"]]["stock1"][
                      "symbol"
                    ] &&
                  item["item"]["stock2"]["symbol"] ===
                    this.state.resultStocks[item["index"]]["stock2"][
                      "symbol"
                    ] ? (
                    <Text
                      style={{
                        width: "10%",
                        justifyContent: "center",
                        fontSize: 30,
                        color: "green",
                        //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                      }}
                    >
                      ✅
                    </Text>
                  ) : (
                    <Text
                      style={{
                        width: "10%",
                        justifyContent: "center",
                        fontSize: 30,
                        //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                      }}
                    >
                      ❌
                    </Text>
                  )
                ) : null}
                {/* {this.state.resultStocks[item["index"]] !== undefined ? (
                  this.state.resultStocks[item["index"]]["stock1"]["symbol"]
                ) : null ? (
                  <Text
                    style={{
                      width: "10%",
                      justifyContent: "center",
                      fontSize: 30,
                      //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                    }}
                  >
                    ✔️
                  </Text>
                ) : (
                  <Text
                    style={{
                      width: "10%",
                      justifyContent: "center",
                      fontSize: 30,
                      //   textDecorationLine: 'line-through', textDecorationStyle: 'solid'
                    }}
                  >
                    ❌
                  </Text>
                )} */}
              </View>
            );
          }}
          keyExtractor={(item, index) => "key" + index}
        />
      </SafeAreaView>
    );
  }
}

export default function (props) {
  const theme = useTheme();

  return <HomeScreen {...props} theme={theme} />;
}
